export default "__VITE_ASSET__$xXZrK7S__"